// import React from 'react'
// import '../Styles/Footer.css'
// import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa'
// import Logo from '../Assets/Assests/final_logo_AI museum.png'
// import { Link } from 'react-router-dom'

// export default function Footer() {
//   return (
//     <footer className='footer bg-dark text-white py-5'>
//       <div className='container'>
//         <div className='row g-4'>
//           {/* Industries Column */}
//           <div className='col-12 col-sm-6 col-lg'>
//             <h3 className='h6 mb-3'>INDUSTRIES</h3>
//             <ul className='list-unstyled small'>
//               <li className='mb-2'>Banking & Financial Services</li>
//               <li className='mb-2'>Energy & Commodities</li>
//               <li className='mb-2'>Healthcare</li>
//               <li className='mb-2'>Public Sector</li>
//               <li className='mb-2'>Retail</li>
//               <li className='mb-2'>Telecommunications Media & Technology</li>
//               <li className='mb-2'>Transportation & Mobility</li>
//             </ul>
//           </div>

//           {/* Services Column */}
//           <div className='col-12 col-sm-6 col-lg'>
//             <h3 className='h6 mb-3'>SERVICES</h3>
//             <ul className='list-unstyled small'>
//               <li className='mb-2'>Business Transformation</li>
//               <li className='mb-2'>Digital Transformation</li>
//               <li className='mb-2'>Learning Transformation</li>
//               <li className='mb-2'>Technology Training Programs</li>
//             </ul>
//           </div>

//           {/* Quick Links Column */}
//           <div className='col-12 col-sm-6 col-lg'>
//             <h3 className='h6 mb-3'>QUICK LINKS</h3>
//             <ul className='list-unstyled small'>
//               <li className='mb-2'>Privacy Policy</li>
//               <li className='mb-2'>Refund Policy</li>
//               <li className='mb-2'>Terms & Conditions</li>
//               <li className='mb-2'>Blogs</li>
//             </ul>
//           </div>

//           {/* Initiatives Column */}
//           <div className='col-12 col-sm-6 col-lg'>
//             <h3 className='h6 mb-3'>INITIATIVES</h3>
//             <ul className='list-unstyled small'>
//               <li className='mb-2'>Panther Diaries</li>
//               <li className='mb-2'>Subscribe HR</li>
//             </ul>
//           </div>

//           {/* Contact Column */}
//           <div className='col-12 col-lg'>
//             <div className='d-flex flex-wrap gap-3 mb-4'>
//               <Link
//                 href='/about-us'
//                 className='text-white text-decoration-none small'
//               >
//                 ABOUT US
//               </Link>
//               <Link
//                 href='/career'
//                 className='text-white text-decoration-none small'
//               >
//                 CAREER
//               </Link>
//               <Link
//                 href='/contact'
//                 className='text-white text-decoration-none small'
//               >
//                 CONTACT US
//               </Link>
//             </div>
//             <div className='d-flex gap-3 mb-4'>
//               <Link href='#' className='text-white hover-purple'>
//                 <FaFacebook size={20} />
//               </Link>
//               <Link
//                 href='https://www.linkedin.com/in/aiglobalmuseum-madan-5a598233b/overlay/about-this-profile/'
//                 className='text-white hover-purple'
//               >
//                 <FaLinkedin size={20} />
//               </Link>
//               <Link
//                 href='https://www.instagram.com/aiglobalmuseum/'
//                 className='text-white hover-purple'
//               >
//                 <FaInstagram size={20} />
//               </Link>
//             </div>
//           </div>
//         </div>

//         {/* Contact Form Section */}
//         <div className='row mt-5 pt-4'>
//           <div className='col-12 text-center mb-4'>
//             <div className='bg-light p-2 rounded'>
//               <img
//                 src={Logo}
//                 alt='Museum Logo'
//                 className='img-fluid'
//                 style={{
//                   maxWidth: '150px',
//                   height: 'auto',
//                   objectFit: 'cover',
//                   borderRadius: '10px',
//                   transition: 'transform 0.3s ease-in-out',
//                 }}
//                 onMouseEnter={(e) => (e.target.style.transform = 'scale(1.1)')}
//                 onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
//               />
//             </div>
//           </div>
//           <div className='col-12 text-center mb-4'>
//             <h3 className='h6'>GET IN TOUCH, ENQUIRE NOW</h3>
//           </div>
//           <div className='col-12'>
//             <form>
//               <div className='row justify-content-center g-3'>
//                 <div className='col-12 col-md-4'>
//                   <input
//                     type='text'
//                     className='form-control bg-transparent text-white border-white'
//                     placeholder='Full Name'
//                   />
//                 </div>
//                 <div className='col-12 col-md-4'>
//                   <input
//                     type='email'
//                     className='form-control bg-transparent text-white border-white'
//                     placeholder='Email'
//                   />
//                 </div>
//                 <div className='col-12 col-md-4'>
//                   <input
//                     type='tel'
//                     className='form-control bg-transparent text-white border-white'
//                     placeholder='Phone No.'
//                   />
//                 </div>
//                 <div className='col-12 text-center mt-4'>
//                   <button className='btn btn-purple px-4' type='submit'>
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//           <div className='col-12 text-center mt-4'>
//             <p className='small text-white'>
//               By submitting this form, I consent to the processing of the
//               personal data that I provide The DataTech Labs Inc. in accordance
//               with and as described in the Privacy Policy and Terms & Conditions
//             </p>
//             <p className='small text-white mt-2'>
//               The DataTech Labs Inc. All rights reserved ©2023
//             </p>
//           </div>
//         </div>
//       </div>
//     </footer>
//   )
// }

import React, { useState } from 'react'
import axios from 'axios'
import '../Styles/Footer.css'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import Logo from '../Assets/Assests/Logos/Tesla bird logo.png'
import { Link } from 'react-router-dom'

export default function Footer() {
  const [formData, setFormData] = useState({
    name: '',
    mobile_number: '',
    email: '',
    note: '',
  })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState({})

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')
    setError({}) // Reset errors

    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Full Name is required'
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)
    ) {
      newErrors.email = 'Invalid email format'
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = 'Phone number is required'
    } else if (!/^\+(?:[0-9] ?){6,14}[0-9]$/.test(formData.mobile_number)) {
      newErrors.mobile_number =
        'Enter a valid mobile number with country code (e.g., +91 9876543210)'
    }

    if (!formData.note.trim()) {
      newErrors.note = 'Comment is required'
    } else if (formData.note.trim().length < 10) {
      newErrors.note = 'Comment must be at least 10 characters'
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      setLoading(false)
      return
    }

    try {
      const response = await axios.post(
        'https://aimuseumbackend.teslabird.com/membership/enquiry/',
        formData
      )
      setMessage('Enquiry submitted successfully!')
      setFormData({ name: '', mobile_number: '', email: '', note: '' })
    } catch (error) {
      setMessage('Failed to submit enquiry. Please try again later.')
    }
    setLoading(false)
  }
  return (
    <footer
      className='footer text-white py-5'
      style={{ backgroundColor: '#2D5272', color: '#ffffff' }}
    >
      <div className='container'>
        <div className='row align-items-center g-4'>
          {/* About Us Section */}
          <div className='col-12 col-lg-4 text-center text-lg-start'>
            <div className='d-flex flex-wrap gap-3 mb-4 justify-content-center justify-content-lg-start'>
              <Link
                to='/privacy-policy'
                className='text-white text-decoration-none small'
              >
                PRIVACY POLICY
              </Link>
              <Link
                to='/contact-us'
                className='text-white text-decoration-none small'
              >
                CONTACT US
              </Link>
              <Link
                to='/shipping-policy'
                className='text-white text-decoration-none small'
              >
                SHIPPING POLICY
              </Link>
            </div>
            <div className='d-flex flex-wrap gap-3 mb-4 justify-content-center justify-content-lg-start'>
              <Link
                to='/terms-conditions'
                className='text-white text-decoration-none small'
              >
                TERMS & CONDITIONS
              </Link>
              <Link
                to='/cancellations-refunds'
                className='text-white text-decoration-none small'
              >
                CANCELLATIONS & REFUNDS
              </Link>
            </div>
            <div className='d-flex gap-3 justify-content-center justify-content-lg-start'>
              <Link
                to='https://x.com/WellnessTesla'
                className='text-white hover-purple'
              >
                <FaTwitter size={20} />
              </Link>
              <Link
                to='https://www.linkedin.com/in/teslabirdwellness/'
                className='text-white hover-purple'
              >
                <FaLinkedin size={20} />
              </Link>
              <Link
                to='https://www.instagram.com/tesla_bird_wellness/'
                className='text-white hover-purple'
              >
                <FaInstagram size={20} />
              </Link>
              <Link
                to='https://www.facebook.com/profile.php?id=61577826801658'
                className='text-white hover-purple'
              >
                <FaFacebook size={20} />
              </Link>
            </div>
          </div>

          {/* Logo Section */}
          <div className='col-12 col-lg-4 text-center'>
            <div className='bg-light p-2 rounded d-inline-block'>
              <img
                src={Logo}
                alt='Museum Logo'
                className='img-fluid'
                style={{
                  maxWidth: '100px',
                  height: 'auto',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  transition: 'transform 0.3s ease-in-out',
                }}
                onMouseEnter={(e) => (e.target.style.transform = 'scale(1.1)')}
                onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
              />
            </div>
          </div>

          {/* Contact Form Section */}
          <div className='col-12 col-lg-4'>
            <h3 className='h6 text-center'>GET IN TOUCH, ENQUIRE NOW</h3>
            <form onSubmit={handleSubmit}>
              <div className='row g-3'>
                <div className='col-12'>
                  <input
                    type='text'
                    className='form-control bg-transparent text-white border-white'
                    placeholder='Full Name'
                    name='name'
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                {error.name && (
                  <p className='small text-warning'>{error.name}</p>
                )}
                <div className='col-12'>
                  <input
                    type='email'
                    className='form-control bg-transparent text-white border-white'
                    placeholder='Email'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                {error.email && (
                  <p className='small text-warning'>{error.email}</p>
                )}
                <div className='col-12'>
                  <input
                    type='tel'
                    className='form-control bg-transparent text-white border-white'
                    placeholder='Phone No.'
                    name='mobile_number'
                    value={formData.mobile_number}
                    onChange={handleChange}
                    required
                  />
                </div>
                {error.mobile_number && (
                  <p className='small text-warning'>{error.mobile_number}</p>
                )}
                <div className='col-12'>
                  <textarea
                    className='form-control bg-transparent text-white border-white'
                    placeholder='Your Comment'
                    name='note'
                    rows='2'
                    value={formData.note}
                    onChange={handleChange}
                  />
                </div>
                {error.note && (
                  <p className='small text-warning'>{error.note}</p>
                )}

                <div className='col-12 text-center mt-2'>
                  <button
                    className='btn px-4'
                    type='submit'
                    disabled={loading}
                    style={{
                      background: '#002740',
                      borderRadius: '20px',
                      color: '#fff',
                    }}
                  >
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
                {message && <p className='text-center small mt-2'>{message}</p>}
              </div>
            </form>
          </div>

          <div className='col-12 text-center mt-4'>
            <p className='small text-white'>
              By submitting this form, I consent to the processing of the
              personal data that I provide MGM Education Trust. in accordance
              with and as described in the Privacy Policy and Terms &
              Conditions.
            </p>
            <p className='small text-white mt-2'>
              MGM Education Trust. All rights reserved ©2025
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
